import axios from 'axios';
import { useCallback, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../../constants';
import { saveToLocal } from './useFetchDownloadTemplate';

interface IUseUploadProductsProps {}

export const useUploadProducts = (props: IUseUploadProductsProps) => {
  const {} = props;
  const [data, setData] = useState();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isUnexpectedError, setIsUnexpectedError] = useState<boolean>(false);

  const fetchingIsDone = () => {
    setTimeout(()=>{
      setIsFetching(false);
    }, 2500)
  }

  const upload = async (file: File) => {
    setIsFetching(true);
    const url = `${API_BASE_URL}/sellers/bulk/stocks`;
    const body = new FormData();
    body.append('file', file);

    try {
      const response = await axios
        .post(url, body, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'blob',
        })
        .then(async (res) => {
          if(res.status === 200 && res.data?.type === "application/json"){
            const resJSON = JSON.parse(await res.data.text());

            return resJSON;
          }

          return res.data;
        });

      setData(response);
      fetchingIsDone();

      if (response?.status_code === 200 && response?.data?.total_affected) {
        setIsError(false);
        setIsUnexpectedError(false);
        setIsSuccess(true);
        return {
          isSuccess: true,
          response,
        };
      }

      setIsError(true);
      setIsUnexpectedError(false);
      setIsSuccess(false);
      return {
        isSuccess: false,
        response,
      };
    } catch (err) {
      console.log(err);
      fetchingIsDone();
      setIsError(true);
      setIsUnexpectedError(true);
      setIsSuccess(false);
      return {
        isSuccess: false,
        response: null,
      };
    }
  };

  const downloadFeedbackFile = () => {
    if (!isError) {
      return;
    }

    saveToLocal(data as unknown as Blob, 'kick-feedback-products-template.xlsx');
  };

  return {
    isFetching,
    isSuccess,
    isError,
    isUnexpectedError,
    data,
    setIsSuccess,
    setIsError,
    setIsUnexpectedError,
    upload,
    downloadFeedbackFile,
  };
};
